import React from 'react'
import glamorous, { Img, Div } from 'glamorous'
import { Link } from 'react-router'

export default () => {
  const UserPhoto = glamorous.div(
    {
      borderRadius: '50%',
      overflow: 'hidden',
      width: 60,
      height: 60,
      marginRight: 8
    }
  )

  const MediaContainer = glamorous.div(
    {
      flexShrink: 0
    }
  )

  const LockupContent = glamorous.div(
    {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  )

  const LockupContainer = glamorous.div(
    {
      display: 'flex',
    }
  )


  return function UserLockup(props) {
    return (
      <Link to={`/~${props.username}`}>
      <LockupContainer>
        <UserPhoto>
          <Img
            display="block"
            maxWidth="100%"
            src={props.avatar}
          />
        </UserPhoto>
        <LockupContent>
          <Div color={props.color}>
            <Div fontSize="22">{props.username}</Div>
            <Div>{`${props.age} · ${props.city}, ${props.region}`}</Div>
          </Div>
        </LockupContent>
      </LockupContainer>
    </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Trips/UserLockup.jsx